var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.255,
    height: 50,
    viewBox: "0 0 29.255 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    width: 50,
    height: 29.255,
    fill: "#fafaf2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0 50) rotate(-90)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M47.524,11.066a18.135,18.135,0,0,1-4.413.025q.659-.868,1.335-1.716A65.019,65.019,0,0,1,37.565,4.89,93.252,93.252,0,0,0,29.221,17.08q-1.243,2.163-2.378,4.394-.9-.059-1.843-.059t-1.843.059q-1.134-2.23-2.378-4.394A93.253,93.253,0,0,0,12.435,4.89,65.02,65.02,0,0,1,5.554,9.375q.676.848,1.335,1.716a18.13,18.13,0,0,1-4.412-.025q-.392-.477-.788-.948L0,8.114,2.181,6.994A61.628,61.628,0,0,0,11.8.839L12.879,0l.912,1.089A96.979,96.979,0,0,1,24.349,16.584q.33.6.651,1.2.321-.6.651-1.2A97.021,97.021,0,0,1,36.209,1.089L37.121,0,38.2.839a61.627,61.627,0,0,0,9.618,6.155L50,8.114l-1.688,2q-.4.47-.788.948",
    transform: "translate(0 7.782)",
    fill: "#fafaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M0,12.688C3.214,6.319,5.17,3.419,5.352,0,5.535,3.419,7.491,6.319,10.7,12.688Q9.576,14.1,8.542,15.619A25.835,25.835,0,0,1,5.352,7.8a25.85,25.85,0,0,1-3.189,7.824Q1.13,14.1,0,12.688",
    transform: "translate(19.647 0)",
    fill: "#fafaf2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLeftArrow);
export default __webpack_public_path__ + "static/media/white-left-arrow.d9ab455e59be07d64806a6bd6936491c.svg";
export { ForwardRef as ReactComponent };